export default "__VITE_ASSET__gSCHfD58__"